import * as React from 'react';
import { bindActionCreators } from 'redux';
import { RouterState, withRouter } from 'react-router';
import { Query } from 'history';
import * as privacyPolicyActions from 'login-actions/privacyPolicyActions';
import { connect } from 'react-redux';
import * as queryString from 'query-string';

import FormDialog from 'login-components/Common/Form/FormDialog/FormDialog';
import AppLayoutContextUpdater from 'login-components/Common/AppLayoutContextUpdater/AppLayoutContextUpdater';
import * as stateUtils from 'login-utils/stateUtils';
import PrivacyPolicyViewer from './PrivacyPolicyViewer';
import './PrivacyPolicy.scss';

export interface PrivacyPolicyProps extends TextScreenState, RouterState {
  title?: string;
}

interface DispatchProps {
  getPrivacyPolicyText: typeof privacyPolicyActions.getPrivacyPolicyText;
}

function getPrivacyPolicyError(query: Query) {
  const errorMessage = stateUtils.getMessageQueryParam(query);
  return errorMessage === 'fetchPrivacyPolicyError'
    ? 'Apologies, we are having some trouble loading your content right now.'
    : undefined;
}

class PrivacyPolicy extends React.Component<PrivacyPolicyProps & DispatchProps, object> {
  componentDidMount() {
    const { getPrivacyPolicyText } = this.props;
    return getPrivacyPolicyText();
  }
  x;
  render() {
    const { content, title, location } = this.props;
    // There will be a render pass where nothing is available; that's fine.
    const htmlText = content as string;
    const query = queryString.parse(location.search);
    const fetchError = getPrivacyPolicyError(query);

    return (
      <div className="PrivacyPolicy">
        <AppLayoutContextUpdater appDocumentTitle={title || 'Blend Privacy Policy'} appTitle={''} footerConfig={null}>
          <FormDialog>
            <PrivacyPolicyViewer htmlText={htmlText} error={fetchError} />
          </FormDialog>
        </AppLayoutContextUpdater>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getPrivacyPolicyText: privacyPolicyActions.getPrivacyPolicyText }, dispatch);
};

const mapStateToProps = state => ({
  ...state.privacyPolicy,
});

const ConnectedPrivacyPolicy = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(PrivacyPolicy),
);

export default ConnectedPrivacyPolicy;
